/**
 * @var {ApiMiddleware}
 */
import { find } from 'lodash'

let api = {}

/**
 * Set root path for api
 * @param {ApiMiddleware} middlewareObject
 */
export const setAclApiMiddleware = middlewareObject => {
    api = middlewareObject
}

export default () => ({
    state: {
        userGroups: [],
    },
    getters: {
        userGroups: state => state.userGroups,
    },
    mutations: {
        setUserGroups(state, userGroups) {
            state.userGroups = userGroups
        },
    },
    actions: {
        async saveAcl({ commit }, data) {
            return api.put(`/userGroup/${data.id}`, data)
        },
        async addAcl({ commit }, data) {
            return api.post(`/userGroup/`, data)
        },
        async deleteAcl({ commit }, id) {
            try {
                return api.delete(`/userGroup/${id}`)
            } catch (e) {
                console.info(e)
            }
        },
        async groupsLoad({ commit }) {
            const userGroups = await api.get('/userGroup?depth=2')
            commit('setUserGroups', userGroups)
        },
    },
})
